import { log } from "../../analytics";
import { events } from "../";

export default (appState, payload, type) => {
  log(events.HOME_VIEWED, {});
};
